import script from "./moveAndTips.vue?vue&type=script&setup=true&lang=js"
export * from "./moveAndTips.vue?vue&type=script&setup=true&lang=js"

import "./moveAndTips.vue?vue&type=style&index=0&id=066a9cab&lang=less"

const __exports__ = script;

export default __exports__